import React, { useMemo, useState } from "react";

const AgentValidation = ({
    isOpen,
    workflow,
    onClose,
    onApprove,
    onReject,
    isSubmitting = false,
    theme = "theme-light",
}) => {
    const [editedValues, setEditedValues] = useState({});

    const isDark = theme === "theme-dark" || theme === "theme-contrast";
    const bg = isDark ? "#1f1f1f" : "#ffffff";
    const border = isDark ? "1px solid rgba(255,255,255,0.2)" : "1px solid rgba(0,0,0,0.15)";
    const textColor = isDark ? "#ffffff" : "#1f1f1f";
    const muted = isDark ? "rgba(255,255,255,0.65)" : "rgba(0,0,0,0.65)";

    const steps = useMemo(() => workflow?.steps || [], [workflow]);

    if (!isOpen || !workflow) return null;

    const resolveValue = (stepId, field) => {
        const key = `${stepId}:${field.name}`;
        if (Object.prototype.hasOwnProperty.call(editedValues, key)) {
            return editedValues[key];
        }
        return field.value ?? "";
    };

    const updateField = (stepId, field, value) => {
        const key = `${stepId}:${field.name}`;
        setEditedValues((prev) => ({ ...prev, [key]: value }));
    };

    const buildPayloadForStep = (step) => {
        const payload = {};
        (step.editableFields || []).forEach((f) => {
            payload[f.name] = resolveValue(step.stepId, f);
        });
        return payload;
    };

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.55)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2200,
                padding: 16,
            }}
        >
            <div
                style={{
                    width: "min(980px, 96vw)",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    borderRadius: 14,
                    background: bg,
                    border,
                    color: textColor,
                    padding: 16,
                }}
            >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 17 }}>Human Validation Required</div>
                        <div style={{ color: muted, fontSize: 12 }}>Review and edit fields before approving each action.</div>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{ border: "none", background: "transparent", color: textColor, cursor: "pointer", fontSize: 18 }}
                        title="Close"
                        disabled={isSubmitting}
                    >
                        ×
                    </button>
                </div>

                {steps.length === 0 ? (
                    <div style={{ color: muted, padding: "8px 0" }}>No validation steps to review.</div>
                ) : (
                    steps.map((step, index) => (
                        <div
                            key={step.stepId || index}
                            style={{
                                border,
                                borderRadius: 10,
                                padding: 12,
                                marginBottom: 10,
                                background: isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.03)",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                <div style={{ fontWeight: 700 }}>
                                    Step {index + 1}: {step.agentName} · {step.action}
                                </div>
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))", gap: 10 }}>
                                {(step.editableFields || []).map((field) => (
                                    <label key={field.name} style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12 }}>
                                        <span style={{ color: muted }}>{field.label || field.name}</span>
                                        <input
                                            value={String(resolveValue(step.stepId, field) ?? "")}
                                            onChange={(e) => updateField(step.stepId, field, e.target.value)}
                                            type={field.type === "email" ? "email" : field.type === "datetime" ? "datetime-local" : "text"}
                                            style={{
                                                border,
                                                borderRadius: 8,
                                                padding: "8px 10px",
                                                background: isDark ? "rgba(255,255,255,0.08)" : "#fff",
                                                color: textColor,
                                            }}
                                            disabled={isSubmitting}
                                        />
                                    </label>
                                ))}
                            </div>

                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 10 }}>
                                <button
                                    type="button"
                                    onClick={() => onReject?.(step)}
                                    disabled={isSubmitting}
                                    style={{ borderRadius: 8, padding: "7px 11px", border, background: "transparent", color: textColor, cursor: "pointer" }}
                                >
                                    Reject
                                </button>
                                <button
                                    type="button"
                                    onClick={() => onApprove?.(step, buildPayloadForStep(step))}
                                    disabled={isSubmitting}
                                    style={{ borderRadius: 8, padding: "7px 11px", border: "none", background: "#0078d4", color: "#fff", cursor: "pointer" }}
                                >
                                    Approve & Execute
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AgentValidation;
